"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menuItemHeight = exports["default"] = exports.baseItemStyles = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _Check = _interopRequireDefault(require("@honeybook/icons/dist/icons/Check16"));
var _Check2 = _interopRequireDefault(require("@honeybook/icons/dist/icons/Check24"));
var _reactDropdownMenu = require("@radix-ui/react-dropdown-menu");
var _styledIs = _interopRequireWildcard(require("styled-is"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _mixins = require("../../styles/mixins");
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//#region Helpers
var SelectedIndicator = function SelectedIndicator(_ref) {
  var item = _ref.item,
    size = _ref.size,
    className = _ref.className;
  if (!item.isSelected) {
    return null;
  }
  if (size === 'md') {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: className
    }, /*#__PURE__*/_react["default"].createElement(Check16Icon, {
      color: _colors["default"].blue20
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(Check24Icon, {
    color: _colors["default"].blue20
  }));
};
var ConditionalWrapper = function ConditionalWrapper(_ref2) {
  var item = _ref2.item,
    children = _ref2.children;
  return item.itemWrapper ? item.itemWrapper({
    children: children
  }) : children;
};

//#endregion

var HBMenuItem = function HBMenuItem(_ref3) {
  var item = _ref3.item,
    size = _ref3.size,
    itemContainerComponent = _ref3.itemContainerComponent;
  var Container = itemContainerComponent || MenuItemContainer;
  var showRightIcon = (item.setTextBeforeIcon && item.icon || !!item.rightIcon) && !item.isSelected;
  var _getTextStyles = getTextStyles(item, size),
    titleType = _getTextStyles.titleType,
    descriptionType = _getTextStyles.descriptionType;
  var testId = item.testId,
    testIdName = item.testIdName;
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'menu-item',
    componentName: 'HBMenuItem'
  });
  return /*#__PURE__*/_react["default"].createElement(ConditionalWrapper, {
    item: item
  }, /*#__PURE__*/_react["default"].createElement(Container, {
    disabled: item.disabled,
    theme: item.theme,
    size: size,
    onClick: item.disabled ? function (e) {
      return e.stopPropagation();
    } : item.onClick,
    $icon: !!item.icon,
    $rightIcon: item.setTextBeforeIcon || !!item.rightIcon,
    $isSelected: item.isSelected,
    $shouldUseIconDefaultFill: item.shouldUseIconDefaultFill,
    $hasDescription: !!item.description,
    "data-testid": finalTestId
  }, !item.setTextBeforeIcon && item.icon && /*#__PURE__*/_react["default"].createElement(LeftIcon, null, item.icon), /*#__PURE__*/_react["default"].createElement(TextWrapper, {
    style: item.textWrapperStyles
  }, /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: titleType
  }, item.title), !!item.description && /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: descriptionType,
    color: "textSecondary"
  }, item.description)), showRightIcon && /*#__PURE__*/_react["default"].createElement(RightIcon, null, item.rightIcon || item.icon), /*#__PURE__*/_react["default"].createElement(StyledSelectedIndicator, {
    item: item,
    size: size
  })));
};
var _default = exports["default"] = HBMenuItem; // -------------------------------- Styles -------------------------------- //
var menuItemHeight = exports.menuItemHeight = (0, _styledComponents.css)(["", " ", " ", " ", ""], (0, _styledIs.match)('size', 'md')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        height: 42px;\n    "]))), (0, _styledIs.match)('size', 'lg')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        height: 49px;\n        font-size: 18px;\n    "]))), (0, _styledIs.match)('size', 'fit')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n        height: fit-content;\n    "]))), (0, _styledIs["default"])('$hasDescription')(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n        height: fit-content;\n    "]))));
var baseItemStyles = exports.baseItemStyles = (0, _styledComponents.css)(["position:relative;outline:none;color:", ";", " cursor:pointer;display:flex;align-items:center;padding:8px 20px;", " ", " ", " &[data-highlighted]{background-color:", ";}&[data-disabled]{cursor:not-allowed;", ";&,*{color:", " !important;}}"], _colors["default"].textPrimary, (0, _styledIs.isNot)('$shouldUseIconDefaultFill')(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n        ", ";\n    "])), (0, _mixins.setIconFillColor)(_colors["default"].textPrimary)), (0, _styledIs["default"])('$hasDescription')(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n        align-items: flex-start;\n    "]))), function (props) {
  return props.$rightIcon && !props.$icon ? 'justify-content: space-between;' : '';
}, menuItemHeight, _colors["default"].neutral100, (0, _mixins.setIconFillColor)(_colors["default"].textDisabled), _colors["default"].textDisabled);
var MenuItemContainer = (0, _styledComponents["default"])(_reactDropdownMenu.Item).withConfig({
  displayName: "HBMenuItem__MenuItemContainer",
  componentId: "sc-1fdknw9-0"
})(["", " ", " ", ""], baseItemStyles, (0, _styledIs.match)('theme', 'destructive')(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n        color: ", ";\n        ", ";\n\n        &[data-highlighted] {\n            background-color: ", ";\n        }\n    "])), _colors["default"].red50, (0, _mixins.setIconFillColor)(_colors["default"].red50), _colors["default"].red50_08), (0, _styledIs["default"])('$isSelected')(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n        background-color: ", ";\n        &[data-highlighted] {\n            background-color: ", ";\n        }\n    "])), _colors["default"].blue20_08, _colors["default"].blue20_08));
var LeftIcon = _styledComponents["default"].div.withConfig({
  displayName: "HBMenuItem__LeftIcon",
  componentId: "sc-1fdknw9-1"
})(["padding-right:12px;i{display:flex;}"]);
var RightIcon = _styledComponents["default"].div.withConfig({
  displayName: "HBMenuItem__RightIcon",
  componentId: "sc-1fdknw9-2"
})(["height:16px;margin-left:auto;", ";"], (0, _mixins.setIconFillColor)(_colors["default"].neutral800));
var Check16Icon = (0, _styledComponents["default"])(_Check["default"]).withConfig({
  displayName: "HBMenuItem__Check16Icon",
  componentId: "sc-1fdknw9-3"
})(["height:16px;margin-left:auto;"]);
var Check24Icon = (0, _styledComponents["default"])(_Check2["default"]).withConfig({
  displayName: "HBMenuItem__Check24Icon",
  componentId: "sc-1fdknw9-4"
})(["height:24px;margin-left:auto;"]);
var TextWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBMenuItem__TextWrapper",
  componentId: "sc-1fdknw9-5"
})(["display:flex;flex-direction:column;gap:6px;"]);

// hack to override the default icon color set in MenuItemContainer
var StyledSelectedIndicator = (0, _styledComponents["default"])(SelectedIndicator).withConfig({
  displayName: "HBMenuItem__StyledSelectedIndicator",
  componentId: "sc-1fdknw9-6"
})(["", " right:20px;", " i{display:flex;}"], _mixins.absoluteCenteredVertical, (0, _mixins.setIconFillColor)(_colors["default"].blue20));
function getTextStyles(item, size) {
  var titleType;
  var descriptionType;
  if (item.description) {
    if (size === 'lg') {
      titleType = 'title18';
      descriptionType = 'body18';
    } else {
      titleType = 'title14';
      descriptionType = 'body14';
    }
  } else if (size === 'lg') {
    titleType = 'body18';
  } else {
    titleType = 'body14';
  }
  return {
    titleType: titleType,
    descriptionType: descriptionType
  };
}
//# sourceMappingURL=HBMenuItem.js.map